import { styled } from "@mui/material";
import { useLocation } from "react-router";
import useStockProduit from "../../../lib/hooks/useStockProduit";

const StyledComponent = styled("div")(({ theme, statutStock }) => ({
	fontFamily: "Sen",
	color: "#fff",
	zIndex: 10,
	backgroundColor: statutStock
		? theme.palette.success.main
		: theme.palette.error.main,
	fontSize: "0.70rem",
	padding: "0 0.5rem",
	borderRadius: 6,
	width: "fit-content",
	[theme.breakpoints.down("sm")]: {
		fontSize: "0.55rem",
	},
}));

export default function StockProductCard({ children, id, stock, unite }) {
	const location = useLocation().pathname;

	const { stockProduit } = useStockProduit(id, stock);

	if (!location.includes("gestion/produits"))
		return (
			<StyledComponent
				statutStock={
					stockProduit ? (stockProduit === 0 ? false : true) : false
				}
			>
				{stockProduit === 0
					? "Rupture de stock"
					: stockProduit + " " + unite + " en vente"}
			</StyledComponent>
		);
	else return null;
}
